/**
 * Gets and e-mail template for e-mails sent from participants list in event form.
 *
 * @param {Object} payload - Payload containing important information about the e-mail.
 * @param {String} payload.conferenceTitle - The conference title.
 * @param {String} payload.conferenceData - The formatted conference date.
 * @param {String} payload.event - The event from where the notification was sent.
 * @param {String} payload.contentTitle - The e-mail content title.
 * @param {String} payload.contentData - The e-mail written by the user.
 * @param {String} payload.register - The e-mail registration sentence.
 * @returns {String} The e-mail template.
 */
export function getInformParticipantsTemplate(payload) {
  return `
    <div style="font-family: 'Arial';background-color: rgb(238, 238, 238);padding: 20px;line-height: 1.6;">
        <div style="margin: auto;
        width: 55%; padding-left: 15px;padding-right: 15px;">
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <img style="width: 100px;padding-right: 15px;height:100px;"
                    src="https://firebasestorage.googleapis.com/v0/b/hci2021.appspot.com/o/utlis%2FnoCity-noBG.png?alt=media&token=5076ac28-dfbe-490f-9f5c-100bc9fdc6e8" />
                <div style="line-height: normal;">
                    <h2>${payload.conferenceTitle}</h2>
                    <p>${payload.conferenceDate}</p>
                </div>
            </div>
        </div>
            <div style="margin: auto; width: 50%;margin-top: 20px;background-color: white;padding: 50px;">
                <h2 style="margin-top: 20px;">
                    ${payload.event}
                </h2>
                <h3 style="margin-top: 20px;">${payload.contentTitle}</h3>
                <div>
                    ${payload.contentData}
                </div>
                <div style="margin-top: 20px;">${payload.register}
                    <a href="https://hci2021.web.app/">https://hci2021.web.app/</a>
                </div>
            </div>
        
    </div>`;
}
